import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    // mode: 'history',
    routes: [{
            path: '/',
            name: 'index',
            redirect: '/home',
            meta: {
                title: '主框架'
            },
            component: index,
            children: [{
                    path: '/home',
                    component: resolve => require(['@/pages/home/home.vue'], resolve),
                    meta: {
                        title: '莫卡乐概念美术馆'
                    }
                }, {
                    path: '/course',
                    component: resolve => require(['@/pages/course/course.vue'], resolve),
                    meta: {
                        title: '课程体系'
                    }
                }, {
                    path: '/courseDetail',
                    name: 'courseDetail',
                    meta: {
                        title: '课程详情',
                    },
                    component: resolve => require(['@/pages/course/courseDetail.vue'], resolve),
                }, {
                    path: '/online',
                    component: resolve => require(['@/pages/online/online.vue'], resolve),
                    meta: {
                        title: '免费网课'
                    }
                }, {
                    path: '/news',
                    component: resolve => require(['@/pages/news/news.vue'], resolve),
                    meta: {
                        title: '新闻'
                    }
                }, {
                    path: '/newsDetail',
                    component: resolve => require(['@/pages/news/newsDetail.vue'], resolve),
                    meta: {
                        title: '新闻详情'
                    }
                }, {
                    path: '/stage',
                    component: resolve => require(['@/pages/stage/stage.vue'], resolve),
                    meta: {
                        title: '小小剧场'
                    }
                },
                /*
                小小剧场路由
                */
                {
                    path: '/stageDetails',
                    meta: {
                        title: '小小剧场',
                        // type: 'login' // 是否需要判断是否登录,这里是需要判断
                    },
                    component: resolve => require(['@/pages/stage/stageDetails.vue'], resolve),
                }, {
                    path: '/stars',
                    component: resolve => require(['@/pages/stars/stars.vue'], resolve),
                    meta: {
                        title: '小明星广场'
                    }
                }, {
                    path: '/teachers',
                    component: resolve => require(['@/pages/teachers/teachers.vue'], resolve),
                    meta: {
                        title: '名师堂'
                    }
                }, {
                    path: '/teacherDetail',
                    component: resolve => require(['@/pages/teachers/teacherDetail.vue'], resolve),
                    meta: {
                        title: '名师详情'
                    }
                }, {
                    path: '/aboutUs',
                    component: resolve => require(['@/pages/aboutUs/aboutUs.vue'], resolve),
                    meta: {
                        title: '关于我们'
                    }
                }, {
                    path: '/contactUs',
                    component: resolve => require(['@/pages/contactUs/contactUs.vue'], resolve),
                    meta: {
                        title: '联系我们'
                    }
                }, {
                    path: '/userPage',
                    component: resolve => require(['@/pages/userPage/userPage.vue'], resolve),
                    meta: {
                        title: '个人中心',
                        type: 'login' // 是否需要判断是否登录,这里是需要判断
                    }
                }, {
                    path: '/search',
                    name: '/search',
                    component: resolve => require(['@/pages/search/search.vue'], resolve),
                    meta: {
                        title: '全局搜索',
                        // type: 'login' // 是否需要判断是否登录,这里是需要判断
                    }
                }
            ],
        }, {
            path: '/login',
            name: 'login',
            meta: {
                title: '登录',
            },
            component: resolve => require(['@/pages/login/login.vue'], resolve),
        },
        //用户管理移动端路由
        {
            path: '/m_addBaby',
            name: 'm_addBaby',
            meta: {
                title: '添加学员',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-addBaby/m_addBaby.vue'], resolve),
        }, {
            path: '/m_editBaby',
            name: 'm_editBaby',
            meta: {
                title: '编辑学员',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-addBaby/m_editBaby.vue'], resolve),
        }, {
            path: '/m_lookBaby',
            name: 'm_lookBaby',
            meta: {
                title: '查看学员',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-lookBaby/m_lookBaby.vue'], resolve),
        }, {
            path: '/m_growUp',
            name: 'm_growUp',
            meta: {
                title: '成长记录',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-growUp/m_growUp.vue'], resolve),
        }, {
            path: '/m_myCourse',
            name: 'm_myCourse',
            meta: {
                title: '我的课程',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-myCourse/m_myCourse.vue'], resolve),
        }, {
            path: '/m_GoodCoins',
            name: 'm_GoodCoins',
            meta: {
                title: '积分明细',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-GoodCoins/m_GoodCoins.vue'], resolve),
        }, {
            path: '/m_userSetting',
            name: 'm_userSetting',
            meta: {
                title: '个人设置',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-userSetting/m_userSetting.vue'], resolve),
        }, {
            path: '/m_editUserData',
            name: 'm_editUserData',
            meta: {
                title: '编辑资料',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-userSetting/m_editUserData.vue'], resolve),
        }, {
            path: '/m_pushGrowUp',
            name: 'm_pushGrowUp',
            meta: {
                title: '发布成长记录',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/userPage/m-growUp/m_pushGrowUp.vue'], resolve),
        },
        //线下课程报名移动端路由
        {
            path: '/m_courseDetail',
            name: 'm_courseDetail',
            meta: {
                title: '课程详情',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/course/m-courseDetail/m_courseDetail.vue'], resolve),
        }, {
            path: '/m_course_enter',
            name: 'm_course_enter',
            meta: {
                title: '预约课程',
                type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/course/m-courseDetail/m_course_enter.vue'], resolve),
        }, {
            path: '/m_notLogin_enter',
            name: 'm_notLogin_enter',
            meta: {
                title: '课程预约',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/course/m-courseDetail/m_notLogin_enter.vue'], resolve),
        }, {
            path: '/m_success_enter',
            name: 'm_success_enter',
            meta: {
                title: '预约成功',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/course/m-courseDetail/m_success_enter.vue'], resolve),
        },
        //小小剧场详情
        {
            path: '/m_stageDetails',
            name: 'm_stageDetails', 
            meta: {
                title: '小小剧场',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/stage/m-stageDetails.vue'], resolve),
        },
        //招生活动页面
        {
            path: '/activity_index',
            name: 'activity_index',
            meta: {
                title: '活动详情',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/activity/activity_index.vue'], resolve),
        }, 
        //招生活动页面
        {
            path: '/activity_page',
            name: 'activity_page',
            meta: {
                title: '活动详情',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            },
            component: resolve => require(['@/pages/activity/activity_page.vue'], resolve),
        }, 

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js